import { render, staticRenderFns } from "./abnormalModalView.vue?vue&type=template&id=a08e2d64&scoped=true&"
import script from "./abnormalModalView.vue?vue&type=script&lang=js&"
export * from "./abnormalModalView.vue?vue&type=script&lang=js&"
import style0 from "./abnormalModalView.vue?vue&type=style&index=0&id=a08e2d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08e2d64",
  null
  
)

export default component.exports